"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nature, Biodiversité et Activités de plein air"}
        backgroundImgSrc={"/images/card-title/Nature-Biodiversite.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>
                  Nature et Biodiversité
                </BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Nature & Biodiversité */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Nature & Biodiversité"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          La Côte d’Ivoire, cette inspirante terre d’hospitalité encore
          verdoyante et fertile vous donne la possibilité d’effectuer un voyage
          qui vous fera certainement grandir au contact d’une nature riche et
          généreuse qui vous livre ses secrets.
          <br />
          <br />
          Des côtes ivoiriennes qui s’étendent du sud-ouest au sud-est,
          illuminées par le soleil et baignées par l’océan Atlantique jusqu’au
          Mont Nimba le plus haut sommet ivoirien, à travers les mangroves
          pleines d’espèces végétales et animalières, ou la richesse forestière
          de la terre d’éburnie s’exprime avec beauté et grâce.
          <br />
          <br />
          Partez à la rencontre d’une nature aux charmes uniques et
          écologiquement protégées à travers les parcs nationaux de :{" "}
          <span className="font-bold">Taï, Comoé, Marahoué</span> et la réserve
          intégrale du <span className="font-bold">Mont Nimba</span> et ses
          extraordinaires crapauds vivipares, inscrit au patrimoine mondial de
          l’Unesco. Le parc des <span className="font-bold">îles Ehotilé</span>{" "}
          et le parc archéologique d’<span className="font-bold">Ahouakro</span>
          figurants sur la liste indicative de l’Unesco font le pont entre la
          nature et les artefacts, témoignage vivant de l’histoire du pays.
          <br />
          <br />
          Sentez l’énergie de ce paradis vert qui possède encore deux forêts
          primaires (forêt de <span className="font-bold">Taï</span> et du{" "}
          <span className="font-bold">banco</span>) avec un climat privilégié et
          une faune unique, de 134 espèces reparties en 5 ordres, 21 familles et
          70 genres. Le plus grand nombre d’espèces (99 espèces) est représenté
          dans le groupe des serpents, suivi par celui des lézards (22 espèces),
          le groupe des tortues (10 espèces) et enfin le groupe des crocodiles
          (3 espèces) etc.
          <br />
          <br />
          Laisser vous tenter que vous soyez amateur, amoureux ou spécialiste de
          la nature vierge.

          <div className={'mt-8'}>
            <ImageGallery images={
              Array.from({ length: 8 }).map((_, index) => ({
                src: `/images/nature-biodiversite/galerie1/${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Quiétude et Félicité */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Quiétude et Félicité"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Fini l’époque des voyages vers une destination trop classique ; le
          tourisme d’aujourd’hui se pratique autrement avec un grand intérêt
          pour les expériences nouvelles authentiques incluant les cultures
          locales et l’approche de la nature plutôt qu’une destination
          spécifique.
          <br />
          <br />
          La Côte d’Ivoire dispose encore de nombreuses potentialités capables
          de vous faire vivre une expérience singulière au sein de lieu de
          dépaysement qui vous ouvrent de nouveaux horizons. Sensibilité
          écologique, retour vers la nature, intérêt pour la consommation et la
          vie locale, etc Votre voyage en terre d’Eburnie en quête de sens, de
          simplicité et d’expériences en réalisant le couplage tourisme
          itinérant & écotourisme pour vos activités outdoor favorites
          (randonnée, camping, observation, etc) et découvrir les richesses
          paysagères, agricoles et patrimoniales des territoires ivoiriens.
          <br />
          <br />
          Allez à vélo ou à pied à la rencontre de cette végétation luxuriante,
          de cette faune diversifiée, de ces parcs et réserves, de ces
          plantations de café et de cacao, de ces fleuves, rivières, cascades et
          plages, de ces villages et ces populations de l’interland ancrés dans
          le folklore , à votre rythme en respectant le concept de durabilité et
          donc en et en accord avec votre conscience pour vivre une expérience
          très personnelle et inédite et riche en émotion.
          <br />
          <br />
          En Côte d’Ivoire, expérimentez, l’art de voyager tout en prenant le
          temps de vous imprégner pleinement de la nature qui nous entoure et de
          la richesse du patrimoine en privilégiant les rencontres, en savourant
          les mets locaux des régions dans le respect du territoire et de ses
          habitants. Le slow tourisme ne s’est jamais si bien exprimé.
          <div className={'mt-8'}>
            <ImageGallery images={
              Array.from({ length: 4 }).map((_, index) => ({
                src: `/images/nature-biodiversite/galerie2/${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
